import { render } from "./BukenRoomList.vue?vue&type=template&id=53e4d4de&ts=true"
import script from "./BukenRoomList.vue?vue&type=script&lang=ts"
export * from "./BukenRoomList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__